import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { createContext, lazy, Suspense, useRef, useState } from 'react';
import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import 'simplebar-react/dist/simplebar.min.css';
import './App.css';
import { NavBar } from './components/navigation';
import './fonts/Andora Modern Serif.otf';

import { HomePage } from './pages/home/page';
import { LibraryMain } from './pages/library/library';

import { ProtectedRoute } from './components/ProtectedRoute'; // Add ProtectedRoute import

// Import secondary pages eagerly for instant navigation without loading delays
import MainAbout from './pages/About/mainAbout';
import ContactNew from './pages/contact/contactNew';
import { CoursesPage } from './pages/Courses/page';
import { GallaryPage } from './pages/gallary/page';
import NotFound from './pages/NotFound';
import ExpertCards from './pages/eventsDetails/event_details';
import PlaylistPage from './pages/playlistPage/playlist';
import CategoryBooks from './pages/books/CategoryBooks';
import PdfViewer from './pages/books/PdfViewer';
import { AdminLibrary } from './pages/admin/AdminLibrary';
import { Login } from './pages/admin/Login';
import RadioPage from './pages/radio/RadioPage';

gsap.registerPlugin(ScrollTrigger);

export const GlobelContext = createContext();

// Subtler Loading component removed for instant transitions

function App() {
  const scrollBarRef = useRef(null);
  const [selectedTab, setSelectedTab] = useState('home');
  const [rebuildlocations, setRebuildlocations] = useState(false);

  const setSelectedtab = (tab) => {
    setSelectedTab(tab);
  };

  const rebuildLocationfn = () => {
    setRebuildlocations(!rebuildlocations);
  };

  return (
    <div className='font-libre' ref={scrollBarRef} id='scrollableBar'>
      <GlobelContext.Provider value={{
        scrollBarRef,
        selectedTab: selectedTab,
        setSelectedtab,
        rebuildLocationfn,
        rebuildlocations
      }}>
        <BrowserRouter>
          <Routes>
            <Route path='/*' element={<AppLayout />} />
          </Routes>
        </BrowserRouter>
      </GlobelContext.Provider>
    </div>
  );
}

function AppLayout() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin') || location.pathname === `/${process.env.REACT_APP_ADMIN_ROUTE || 'admin-library'}`;

  return (
    <div className="relative min-h-screen">
      {!isAdminRoute && <NavBar />}
      <Routes>
        <Route index element={<Navigate to={'/home'} replace />} />
        <Route path='/home' element={<HomePage />} />
        <Route path='/contact' element={<ContactNew />} />
        <Route path='/about' element={<MainAbout />} />
        <Route path='/library' element={<LibraryMain />} />
        <Route path='/library/:playlistId' element={<PlaylistPage />} />
        <Route path='/courses' element={<CoursesPage />} />
        <Route path='/gallery' element={<GallaryPage />} />
        <Route path='/events-details' element={<ExpertCards />} />
        <Route path='/events-details/:id' element={<ExpertCards />} />
        <Route path='/books/:categoryId' element={<CategoryBooks />} />
        <Route path='/view-pdf' element={<PdfViewer />} />
        <Route path='/radio' element={<RadioPage />} />
        <Route path={`/${process.env.REACT_APP_ADMIN_ROUTE || 'admin-library'}`} element={<ProtectedRoute><AdminLibrary /></ProtectedRoute>} /> {/* Added ProtectedRoute wrapper */}
        <Route path="/admin/login" element={<Login />} /> {/* Added Login route */}
        <Route path='*' element={<NotFound />} />
      </Routes>
    </div>
  );
}

export default App;


